var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import FileUpload from "~/components/common/file-upload.vue";
import { CaseVerifyService } from "~/services/domain-service/case-verify.service";
var VerifyFileUpload = /** @class */ (function (_super) {
    __extends(VerifyFileUpload, _super);
    function VerifyFileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.model = {
            fileIds: "",
            description: ""
        };
        _this.rules = {
            fileIds: { required: true, message: "请上传附件" },
            description: { required: true, message: "请输入说明" }
        };
        return _this;
    }
    VerifyFileUpload.prototype.watchFileList = function () {
        this.model.fileIds = this.fileList.length === 0 ? "" : this.fileList.map(function (v) { return v.response.id; }).join(",");
    };
    VerifyFileUpload.prototype.refreshData = function () { };
    VerifyFileUpload.prototype.close = function () {
        var form = this.$refs['form'];
        form.resetFields();
        this.fileList = [];
    };
    VerifyFileUpload.prototype.commit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (v) {
            if (!v)
                return;
            _this.caseVerifyService.uploadCaseVerifyFile(__assign(__assign({}, _this.model), { caseId: _this.rowData.id })).subscribe(function (data) {
                _this.$message.success("上传成功");
                _this.refreshData();
                _this.close();
            });
        });
    };
    __decorate([
        Dependencies(CaseVerifyService)
    ], VerifyFileUpload.prototype, "caseVerifyService", void 0);
    __decorate([
        Prop({ required: true })
    ], VerifyFileUpload.prototype, "rowData", void 0);
    __decorate([
        Watch("fileList", { deep: true })
    ], VerifyFileUpload.prototype, "watchFileList", null);
    __decorate([
        Emit("refreshData")
    ], VerifyFileUpload.prototype, "refreshData", null);
    __decorate([
        Emit("close")
    ], VerifyFileUpload.prototype, "close", null);
    VerifyFileUpload = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], VerifyFileUpload);
    return VerifyFileUpload;
}(Vue));
export default VerifyFileUpload;
